import api from './axios';

// 上游地址仅由03后端读取，内容全部保存于01。
export const getContentApiBaseUrl = () => '/api';
export const resetContentApiConfig = () => {};
export const ensureContentApiConfigured = () => Promise.resolve('/api');

export default api;
